import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import styled from 'styled-components';

import { Sport } from '__generated__/globalTypes';
import { FontAwesomeIcon } from 'atoms/icons';
import { FootballLogo } from 'atoms/icons/FootballLogo';
import { MLBLogo } from 'atoms/icons/MLBLogo';
import { NBALogo } from 'atoms/icons/NBALogo';
import { Horizontal } from 'atoms/layout/flex';
import { LabelM } from 'atoms/typography';
import { Ellipsis } from 'atoms/typography/Ellipsis';
import { Avatar } from 'components/user/Avatar';
import { useCurrentUserContext } from 'contexts/currentUser';
import { useIsLaptop } from 'hooks/device/useIsLaptop';

const Root = styled(Horizontal).attrs({ gap: 1.5, center: true })`
  position: relative;
  padding: var(--half-unit);
  border-radius: var(--triple-unit);
  padding-right: var(--unit);

  &:hover {
    background-color: var(--c-nd-50);
  }
`;
const SportIcon = styled(Horizontal).attrs({ center: true })`
  position: absolute;
  right: 0;
  bottom: 0;

  border: 2px solid var(--c-black);
  border-radius: 50%;
  width: var(--triple-unit);
  height: var(--triple-unit);
`;

const sportIcons = {
  [Sport.FOOTBALL]: <FootballLogo />,
  [Sport.BASEBALL]: <MLBLogo />,
  [Sport.NBA]: <NBALogo />,
};

type Props = { sport: Sport; active?: boolean };
export const ProfileButtonContent = ({ sport, active }: Props) => {
  const { currentUser } = useCurrentUserContext();
  const isLaptopAndAbove = useIsLaptop();

  if (!currentUser) {
    return null;
  }

  if (!isLaptopAndAbove) {
    return (
      <Root>
        <Avatar user={currentUser} rounded size={5} />
        <SportIcon>{sportIcons[sport]}</SportIcon>
      </Root>
    );
  }

  return (
    <Root>
      <Avatar user={currentUser} rounded size={4} />
      <Ellipsis>
        <LabelM bold>{currentUser.nickname}</LabelM>
      </Ellipsis>
      <FontAwesomeIcon icon={active ? faChevronUp : faChevronDown} />
    </Root>
  );
};
